(() => {
  const ready = () => {
    const hero = document.querySelector('[data-luxury-hero]');
    if (!hero) return;
    hero.classList.add('bts59-hero-live');

    /* Restart the signature hero sequence on bfcache restores and theme-editor refreshes. */
    const mark = hero.querySelector('.bts-hero-mark');
    if (mark && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      mark.addEventListener('animationiteration', () => hero.classList.toggle('bts59-pulse'));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once:true });
  else ready();
})();
